package dev.wyns.ventrova.ui.web.cupertino

import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.spring
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsPressedAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.composed
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.kyant.backdrop.Backdrop
import com.kyant.backdrop.drawBackdrop
import com.kyant.backdrop.effects.blur
import com.kyant.backdrop.effects.lens
import com.kyant.backdrop.effects.vibrancy
import com.kyant.shapes.Capsule
import com.kyant.shapes.RoundedRectangle

/**
 * Liquid Glass imitation (Kyant's Backdrop): the [backdrop] behind the element is refracted at the
 * edges (lens), blurred and made more vibrant, with a light [surface] tint on top.
 */
fun Modifier.liquidGlass(
    backdrop: Backdrop,
    shape: () -> Shape = { Capsule() },
    surface: Color = Color.White.copy(alpha = 0.35f),
    blurRadius: Dp = 3.dp,
    refraction: Dp = 14.dp,
): Modifier = drawBackdrop(
    backdrop = backdrop,
    shape = shape,
    effects = {
        vibrancy()
        blur(blurRadius.toPx())
        lens(refraction.toPx(), refraction.toPx() * 2)
    },
    onDrawSurface = { drawRect(surface) },
)

fun roundedGlass(radius: Dp): () -> Shape = { RoundedRectangle(radius) }

/** Click with the springy "press in" response of iOS 26 glass controls. */
fun Modifier.glassClickable(enabled: Boolean = true, onClick: () -> Unit): Modifier = composed {
    val interaction = remember { MutableInteractionSource() }
    val pressed by interaction.collectIsPressedAsState()
    val scale by animateFloatAsState(if (pressed) 1.06f else 1f, spring(dampingRatio = 0.5f, stiffness = 400f))
    graphicsLayer {
        scaleX = scale
        scaleY = scale
    }.clickable(interactionSource = interaction, indication = null, enabled = enabled, onClick = onClick)
}
